import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { batch, connect } from "react-redux";
import { StyledTimelineContainer } from "./styled";
import Seeker from "./Seeker";
import { TimelineContext } from "../../_utils/timeline";
import { DURATION_PIXEL_RATIO } from "../../_components/styled/variable";
import Rail from "./Rail";
import Ruler from "./Ruler";
import { openAdvancedSettings } from "../../_actions/sidebarSliderActions";
import dayjs from "dayjs";
import { STILL_EFFECT } from "../../_components/details/advanced/animations/defaultLayerAnimations";
import LayerBlock from "./LayerBlock";
import {
  ADVANCED_ANIMATION_PANEL,
  ADVANCED_EDITOR_EDIT,
  STILL,
} from "../../_components/details/constants";
import { STILL_ANIMATION } from "../../_components/details/advanced/animations/defaultSlideTransitions";
import { getMIMETypeFromFabricObject } from "../../_utils/common";
import { selectArtboard } from "../../_actions/motionActions";
import {
  StyledLayerTimelineTable,
  StyledLayerTimelineTitle,
} from "../../_components/styled/details/styleArtBoardEditor";
import {
  FaFont,
  FaImage,
  FaObjectGroup,
  FaShapes,
  FaVideo,
} from "react-icons/fa";
import { Box, Text } from "@chakra-ui/react";

const getUpdatedAnimationAttributes = (newStart, newEnd, layerObject) => {
  const newDuration = newEnd - newStart;
  let currentAnimations = layerObject?.payload?.animation;

  let newAnimations = null;

  if (!currentAnimations || currentAnimations?.length === 0) {
    newAnimations = [
      {
        ...STILL_EFFECT,
        start_time: newStart,
        trans_duration: newDuration,
        end_time: newEnd,
      },
    ];
  } else {
    const oldStart = currentAnimations[0].start_time;
    let oldDuration = 0;
    let durationWithoutStillAnimations = 0;
    for (const a of currentAnimations) {
      oldDuration += a.trans_duration;
      if (a.type === STILL) {
      } else {
        durationWithoutStillAnimations += a.trans_duration;
      }
    }
    const oldEnd = oldStart + oldDuration;
    const offsetToAdjustInStillDuration = newDuration - oldDuration;

    let prevOffset = newStart;
    newAnimations = currentAnimations.map((a) => {
      const animationStart = prevOffset;
      let transDuration = a.trans_duration;

      if (a.type === STILL_ANIMATION.id) {
        if (offsetToAdjustInStillDuration < 0) {
          // if(Math.abs(offsetToAdjustInStillDuration) > a.trans_duration){

          // }else{
          transDuration = a.trans_duration + offsetToAdjustInStillDuration;

          // }
        } else {
          transDuration = a.trans_duration + offsetToAdjustInStillDuration;
        }
      }

      prevOffset = animationStart + transDuration;
      return {
        ...a,
        start_time: animationStart,
        trans_duration: transDuration,
        end_time: prevOffset,
      };
    });
  }

  const updatedLayer = {
    ...layerObject,
    payload: {
      ...layerObject.payload,
      animation: newAnimations,
    },
  };
  if (layerObject.mime === "video") {
    updatedLayer.payload.endTime =
      (updatedLayer?.payload?.startTime ?? 0) + newDuration / 1000;
  }
  return updatedLayer;
};

const getIconFromMimeType = (mime) => {
  switch (mime) {
    case "image":
      return <FaImage className="icon" />;
    case "text":
      return <FaFont className="icon" />;
    case "group":
      return <FaObjectGroup className="icon" />;
    case "video":
      return <FaVideo className="icon" />;
    case "shape":
      return <FaShapes className="icon" />;
    default:
      return <FaImage className="icon" />;
  }
};

export const LayerTimelineComponent = ({
  activePage,
  activeElement,
  layers,
  openAdvancedSettings,
  selectArtboard,
}) => {
  const {
    duration,
    pagesData,
    currentTime,
    seek,
    timescale,
    updateArtboardDuration,
    canvasRef,
  } = useContext(TimelineContext);

  const [layersDataWithWidth, setLayersDataWithWidth] = useState([]);

  let railLength = 0;

  railLength = currentTime * DURATION_PIXEL_RATIO * timescale;
  const seekerTrack = useRef(null);
  const timelineContainer = useRef(null);

  // On change the position of the seeker
  const onChangePosition = (e, d) => {
    const seekDurationInSeconds = d.x / (DURATION_PIXEL_RATIO * timescale);
    seek(seekDurationInSeconds);
  };

  const intervalSeconds = useMemo(() => {
    // if (timescale >= 2) {
    //   return 1;
    // }else if(timescale <= 0.5) {
    //   return 4;
    // }
    return Math.ceil(2 / timescale);
  }, [timescale]);

  const buildData = (layersData = []) => {
    return layersData.map((l) => {
      let layerAnimation = l?.payload?.animation;
      if (!layerAnimation || (layerAnimation && layerAnimation.length === 0)) {
        layerAnimation = [
          {
            ...STILL_EFFECT,
            start_time: 0,
            trans_duration: duration * 1000,
            end_time: duration * 1000,
          },
        ];
      }
      let startTime = layerAnimation[0].start_time;
      let layerDuration = 0;
      let layerAnimationDuration = 0;
      for (const a of layerAnimation) {
        layerDuration += a.trans_duration;
        if (a.type !== STILL) {
          layerAnimationDuration += a.trans_duration;
        }
      }
      const offset = (startTime * DURATION_PIXEL_RATIO * timescale) / 1000;
      const width = (layerDuration * DURATION_PIXEL_RATIO * timescale) / 1000;
      const minDuration = layerAnimationDuration + 500;
      l.offset = offset;
      l.width = width;
      l.minWidth = (minDuration / 1000) * DURATION_PIXEL_RATIO * timescale;
      return l;
    });
  };

  useEffect(() => {
    seek(0);
  }, []);

  useEffect(() => {
    if (!pagesData || (pagesData && pagesData.length === 0)) {
      setLayersDataWithWidth([]);
    } else {
      const pageLayers = pagesData[0].layers;
      if (pageLayers.length === 0) {
        selectArtboard();
      } else {
        const updatedLayers = buildData(
          pagesData[0].layers.map((l) => layers[l])
        );
        setLayersDataWithWidth(updatedLayers);
      }
    }
  }, [pagesData, layers, timescale]);

  const onDragLayerBlock = async (
    e,
    { x, node },
    index = null,
    commit = false
  ) => {
    const newLayersDataWithWidth = layersDataWithWidth.map((l, idx) => {
      if (idx === index) {
        return {
          ...l,
          offset: x,
          width: node.offsetWidth,
        };
      }
      return l;
    });
    setLayersDataWithWidth(newLayersDataWithWidth);
    if (commit) {
      let updatedLayer = newLayersDataWithWidth[index];
      let oldStart = 0;
      let oldEnd = 0;
      if (updatedLayer.payload?.animation) {
        oldStart = updatedLayer.payload?.animation[0].start_time;
        const duration = updatedLayer.payload?.animation.reduce(
          (a, c) => a + c.trans_duration,
          0
        );
        oldEnd = oldStart + duration;
      } else {
        oldEnd =
          (updatedLayer.width * 1000) / (timescale * DURATION_PIXEL_RATIO);
      }
      const newStart =
        (updatedLayer.offset * 1000) / (timescale * DURATION_PIXEL_RATIO);
      const duration =
        (updatedLayer.width * 1000) / (timescale * DURATION_PIXEL_RATIO);
      const newEnd = newStart + duration;
      if (oldStart !== newStart || oldEnd !== newEnd) {
        updatedLayer = getUpdatedAnimationAttributes(
          newStart,
          newEnd,
          updatedLayer
        );

        const layerObj = canvasRef.handler.findById(updatedLayer.id);
        layerObj.set({
          animation: updatedLayer.payload?.animation,
          startTime: updatedLayer.payload?.startTime,
          endTime: updatedLayer.payload?.endTime,
        });
        canvasRef.handler.onModified(layerObj);
      }
    }
  };

  const onResizeLayerBlock = async (
    e,
    direction,
    ref,
    delta,
    pos,
    index = null,
    commit = false
  ) => {
    const newLayersDataWithWidth = layersDataWithWidth.map((l, idx) => {
      if (idx === index) {
        return {
          ...l,
          offset: pos.x,
          width: ref.offsetWidth,
        };
      }
      return l;
    });
    setLayersDataWithWidth(newLayersDataWithWidth);
    if (commit) {
      let updatedLayer = newLayersDataWithWidth[index];
      const newStart =
        (updatedLayer.offset * 1000) / (timescale * DURATION_PIXEL_RATIO);
      const duration =
        (updatedLayer.width * 1000) / (timescale * DURATION_PIXEL_RATIO);
      const newEnd = newStart + duration;
      updatedLayer = getUpdatedAnimationAttributes(
        newStart,
        newEnd,
        updatedLayer
      );
      const layerObj = canvasRef.handler.findById(updatedLayer.id);
      layerObj.set({
        animation: updatedLayer.payload?.animation,
        startTime: updatedLayer.payload?.startTime,
        endTime: updatedLayer.payload?.endTime,
      });
      canvasRef.handler.onModified(layerObj);
    }
  };

  return (
    <StyledTimelineContainer id={"timeline-container"} ref={timelineContainer}>
      <StyledLayerTimelineTable
        style={{ color: "white", marginBottom: "1rem" }}
      >
        <tbody>
          <tr>
            <td className="first-column">
              <span className="artboard-title">
                Artboard {activePage.pageIndex + 1}
              </span>
            </td>
            <td style={{ background: "rgba(30, 30, 30, 1)" }}>
              <Box
                id="seeker-track-layer-view"
                ref={seekerTrack}
                width={DURATION_PIXEL_RATIO * timescale * duration}
              >
                <Seeker
                  pos={railLength} //current position of seeker
                  parentId="#seeker-track-layer-view"
                  onChangePosition={onChangePosition}
                />
              </Box>
              <Ruler
                id="timeline-ruler"
                duration={duration}
                scale={timescale}
                onSeek={seek}
                width={"100%"}
                height={30}
                backgroundColor={"transparent"}
                style={{
                  width: "100%",
                  height: 30,
                  cursor: "pointer",
                }}
                longLineSize={8}
                shortLineSize={4}
                segment={5}
                unit={intervalSeconds}
                onClick={(s) => seek(Math.min(s, duration))}
                textAlign={"center"}
                textFormat={(v) => {
                  if (duration > 30) {
                    return dayjs.duration(v, "seconds").format("mm:ss");
                  } else {
                    return `${Number(v).toFixed(1)}s`;
                  }
                }}
                showFirstTextLeftAligned
              />
            </td>
          </tr>
          {layersDataWithWidth.map((layer, index) => {
            const mime = getMIMETypeFromFabricObject(layer?.payload?.type);
            return (
              <tr key={`layer-row-${index}`}>
                <td className="first-column">
                  <StyledLayerTimelineTitle
                    $isActive={layer?.id === activeElement?.id}
                    onClick={(e) => {
                      if (canvasRef && layer?.id !== activeElement?.id) {
                        canvasRef.handler.searchAndSelect(layer?.id);
                      }
                    }}
                  >
                    <div className="icon">{getIconFromMimeType(mime)}</div>
                    <Text className="title" textTransform="capitalize">
                      {mime}
                    </Text>
                  </StyledLayerTimelineTitle>
                </td>
                <td>
                  <Rail
                    id={`layer-rail-${layer.id}`}
                    height="32px"
                    width={duration * DURATION_PIXEL_RATIO * timescale}
                    alwaysShowTrack={true}
                    railStyles={{
                      background: "rgba(50, 50, 50, 1)",
                      p: 0,
                      my: 1,
                    }}
                  >
                    <LayerBlock
                      enabled={currentTime === 0}
                      isActive={layer?.id === activeElement?.id}
                      index={index}
                      parentId={`#layer-rail-${layer.id}`}
                      layer={layer}
                      width={layer.width}
                      offset={layer.offset}
                      minWidth={layer.minWidth}
                      onClick={(e) => {
                        if (
                          canvasRef &&
                          layer?.id !== activeElement?.id &&
                          currentTime === 0
                        ) {
                          canvasRef.handler.searchAndSelect(layer?.id);
                        }
                      }}
                      onDrag={(...args) => {
                        onDragLayerBlock(...args, index);
                      }}
                      onResize={(...args) => {
                        onResizeLayerBlock(...args, index);
                      }}
                      onDragStop={(...args) => {
                        onDragLayerBlock(...args, index, true);
                      }}
                      onResizeStop={(...args) => {
                        onResizeLayerBlock(...args, index, true);
                      }}
                      onClickAnimationOptions={(e) => {
                        batch(() => {
                          if (canvasRef && layer?.id !== activeElement?.id) {
                            canvasRef.handler.searchAndSelect(layer?.id);
                          }
                          openAdvancedSettings(
                            ADVANCED_ANIMATION_PANEL,
                            ADVANCED_EDITOR_EDIT
                          );
                        });
                      }}
                    />
                  </Rail>
                </td>
              </tr>
            );
          })}
        </tbody>
      </StyledLayerTimelineTable>
    </StyledTimelineContainer>
  );
};

LayerTimelineComponent.propTypes = {};

const mapStateToProps = (state) => ({
  activePage: state.editor.activePage,
  activeElement: state.editor.activeElement,
  pages: state.pagestore?.pages,
  layers: state.layerstore?.layers,
});

const mapDispatchToProps = (dispatch) => ({
  openAdvancedSettings: (panelName, selectedTab) =>
    dispatch(openAdvancedSettings(panelName, selectedTab, null, false)),
  selectArtboard: (id = null, idx = null) => dispatch(selectArtboard(id, idx)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LayerTimelineComponent);
